"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wizard = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _utils = require("@creditas/utils");

var _Step = require("./Step");

var _components = require("./components");

var _core = require("@emotion/core");

const propTypes = process.env.NODE_ENV !== "production" ? {
  component: (0, _propTypes.oneOfType)([_propTypes.elementType, _propTypes.string]),
  className: _propTypes.string,
  'data-testid': _propTypes.string,
  steps: _propTypes.array,
  currentStep: _propTypes.number,
  direction: _propTypes.string
} : {};
const defaultProps = {
  component: 'div'
};

const Wizard = ({
  component,
  steps,
  currentStep,
  ...others
}) => (0, _core.jsx)(_components.WizardWrapper, (0, _extends2.default)({
  as: component
}, others), (0, _core.jsx)(_components.WizardContainer, null, steps.map((step, i) => {
  const stepVariant = step === currentStep ? 'active' : step < currentStep ? 'success' : 'disabled';
  return (0, _core.jsx)(_Step.Step, {
    lastStep: !steps[i + 1],
    variant: stepVariant,
    key: step
  });
})));

process.env.NODE_ENV !== "production" ? Wizard.propTypes = propTypes : void 0;
Wizard.defaultProps = defaultProps;
const WithForwardRef = (0, _utils.withForwardRef)(Wizard);
exports.Wizard = WithForwardRef;